import React from 'react'

export default function Handle({
  handle: { id, value, percent },
  getHandleProps,
  sliderDomain
}) {
  return (
    <div
      className="slider-handle"
      style={{
        left: `${percent}%`
      }}
      {...getHandleProps(id)}
    >
      <div className="slider-value">
        {
          Math.round(
            (
              (value - sliderDomain[0]) /
              (sliderDomain[1] - sliderDomain[0])
            )
            * 100)
        }
      </div>
    </div>
  )
}
